import styled from "styled-components"

const ExpandedMenuMobile0 = () => {
  return (
    <ExpandedMenuDiv>
      <SubMenuDiv>회사 소개</SubMenuDiv>
      <SubMenuDiv>학문프로파일 소개</SubMenuDiv>
      <SubMenuDiv>학과 정보</SubMenuDiv>
    </ExpandedMenuDiv>
  )
}

export default ExpandedMenuMobile0

const ExpandedMenuDiv = styled.div`
  display: flex;
  flex-direction: column;
`

const SubMenuDiv = styled.div`
  height: 40px;
  font-size: 16px;
  line-height: 40px;
`
